import { render, staticRenderFns } from "./AppAnnouncements.vue?vue&type=template&id=6162ecaa&scoped=true&"
import script from "./AppAnnouncements.vue?vue&type=script&lang=js&"
export * from "./AppAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./AppAnnouncements.vue?vue&type=style&index=0&id=6162ecaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162ecaa",
  null
  
)

export default component.exports